export interface ISecondInterview {
    id: number;
    applicantId: number;
    interviewDate?: Date;
    expectedSalary?: number;
    notes?: string;
    availableOn: string;
    questions: string;
   hrInterviewVideoId?: number;
    hrInterviewVideoURL?: string;
    currencyTypeId?: number;
    sharedNotes?: any[]
}
export class SecondInterview {
    applicantId: number;
    interviewDate?: Date;
    expectedSalary?: number;
    notes?: string;
    availableOn?: string;
    id: number;
    interviewType = 'Second';
    questions: string | any;
    logListId?: number;
 hrInterviewVideoId?: number;
    hrInterviewVideoURL?: string;
    currencyTypeId?: number;
    sharedNotes?: any[];
    constructor(obj?: ISecondInterview) {
        this.applicantId = obj && obj.applicantId || null;
        this.interviewDate = obj && obj.interviewDate || null;
        this.expectedSalary = obj && obj.expectedSalary || null;
        this.notes = obj && obj.notes || '';
        this.availableOn = obj && obj.availableOn || null;
        this.id = obj && obj.id || 0;
        this.hrInterviewVideoId = obj && obj.hrInterviewVideoId || null;
        this.hrInterviewVideoURL = obj && obj.hrInterviewVideoURL || null;
        this.currencyTypeId = obj && obj.currencyTypeId || null;
        this.questions = obj && obj.questions ? JSON.parse(obj.questions) : '';
        this.sharedNotes = obj && obj.sharedNotes || [];
    }
}

